import React from 'react'
import tw from 'twin.macro'
import styled from 'styled-components'
import { ERC20Token, SerializedToken } from '@nominex/nomiswap-sdk'
import { SlIconButton, SlTooltip } from '@shoelace-style/shoelace/dist/react'
import { useTranslation } from 'contexts/Localization'
import { useWagmi } from 'libs/wagmi'
import { getTokenLogoURL } from 'utils/getTokenLogoURL'

const StyledSlIconButton = styled(SlIconButton)`
  &::part(base) {
    ${tw`p-0`}
  }
`

const DEFAULT_CONNECTOR = 'MetaMask'

const canRegisterToken = (connector) =>
  [DEFAULT_CONNECTOR, 'Coinbase Wallet', 'TokenPocket', 'Trust Wallet'].includes(connector?.name)

const watchAsset = (token: SerializedToken, image: string, connector) => {
  connector.watchAsset?.({
    address: token.address,
    symbol: token.symbol,
    decimals: token.decimals,
    ...(image && { image }),
  })
}

const AddToWalletButton: React.FC<{ token: SerializedToken }> = ({ token }) => {
  const { t } = useTranslation()
  const { connector, isConnected } = useWagmi()

  if (!(connector && connector.watchAsset && isConnected) || !canRegisterToken(connector)) {
    return null
  }

  const tokenLogoUrl = getTokenLogoURL(token as ERC20Token)

  return (
    <SlTooltip content={t('Add %symbol% to wallet', { symbol: token.symbol })} hoist>
      <StyledSlIconButton name="wallet" library="unicons" onClick={() => watchAsset(token, tokenLogoUrl, connector)} />
    </SlTooltip>
  )
}

export default AddToWalletButton
